import { createAction, handleActions } from 'redux-actions';

export const resetLogin = createAction('RESET_LOGIN');
export const setUser = createAction('SET_USER');
export const setIsProfileSubmitted = createAction('SET_IS_PROFILE_SUBMITTED');
export const setIsInvitationLoading = createAction('SET_INVITATION_LOADING');
export const setIsClientActivated = createAction('SET_IS_CLIENT_ACTIVATED');
export const resetInvitationState = createAction('RESET_INVITATION_STATE');

const LOGIN_INITIAL_STATE = {
  id: '',
  emailAddress: '',
  fullName: '',
  fullNameLowerCase: '',
  company: '',
  companyLowerCase: '',
  phoneNumber: '',
  address: {
    state: '',
    city: '',
    zipcode: '',
    country: '',
    countryCode: '',
  },
  status: '',
  isSuperAdmin: false,
  noOfExperience: 0,
  isProfileCompleted: false,
  isProfileSubmitted: true,
  businessAddress: '',
  createdAt: 0,
  noOfGuidedTour: 0,
  noOfTreasureHunt: 0,
  joinedDate: 0,
  createdBy: 0,
  updatedAt: 0,
  updatedBy: 0,
};

const INVITATION_INITIAL_STATE = {
  isInvitationLoading: false,
  isClientActivated: false,
};

const INITIAL_STATE = {
  ...LOGIN_INITIAL_STATE,
  ...INVITATION_INITIAL_STATE,
};

export default handleActions(
  {
    RESET_LOGIN: state => ({ ...state, ...LOGIN_INITIAL_STATE }),
    RESET_INVITATION_STATE: state => ({ ...state, ...INVITATION_INITIAL_STATE }),
    SET_USER: (state, action) => ({ ...state, ...action.payload }),
    SET_IS_PROFILE_SUBMITTED: (state, action) => ({ ...state, isProfileSubmitted: action.payload }),
    SET_INVITATION_LOADING: (state, action) => ({ ...state, isInvitationLoading: action.payload }),
    SET_IS_CLIENT_ACTIVATED: (state, action) => ({ ...state, isClientActivated: action.payload }),
  },
  INITIAL_STATE
);
